var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 28,
    rx: 6,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2983 14.376V10.792H13.1743C14.6303 10.792 15.2463 11.464 15.2463 12.598C15.2463 13.69 14.6303 14.376 13.1743 14.376H11.2983ZM16.5483 12.598C16.5483 11.002 15.4703 9.742 13.1743 9.742H10.0243V19.5H11.2983V15.426H13.1743C15.5963 15.426 16.5483 14.082 16.5483 12.598Z",
    fill: "#2C6A04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterP);
export default __webpack_public_path__ + "static/media/letter-p.7c117cec1a64f44c0ddc64c01a7be22c.svg";
export { ForwardRef as ReactComponent };